<script>
import {formatAddress, formatDate, formatPages} from "../../helpers/inventories"
import PersonDetails from "../../components/persons/person-details";
import Loader from "../../components/loader";

import api from "../../services/api";
import PersonInline from "@/components/persons/person-inline.vue";

/**
 * Nav-bar Component
 */
export default {
  components: {PersonInline, PersonDetails, Loader},
  props: {
    resource: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      singleImage: false,
      selectedPerson: null,
      localInventory: null,
      loading: false,
      inventory: this.resource
    };
  },
  methods: {
    formatAddress(item) {
      return formatAddress(item);
    },
    formatDate(item) {
      return formatDate(item);
    },
    formatPages(item) {
      return formatPages(item);
    },
    async loadInventory() {
      this.loading = true;
      return await api.get(
          "inventories",
          {
            id: this.inventory.id,
            with: 'support,register,numerisation,date,date_end,address,authors,persons,pages'
          }
      )
          .then((response) => {
            this.localInventory = response.data
          })
          .finally(() => {
            this.loading = false;
          });
    }
  },
  created() {
    this.localInventory = this.loadInventory();
  }
};
</script>

<template>
  <Loader :loading="loading">
    <b-card no-body>
      <b-card-body>
        <h5>{{ localInventory.exploitation_number }} <span
            class="badge badge-soft-info">{{ localInventory.inventory_number }}</span></h5>
        <h5>{{ localInventory.title }}</h5>

        <ul class="list-inline">
          <li class="list-inline-item me-3" v-if="localInventory.authors && localInventory.authors.length !== 0"><i
              class='bx bx-camera'></i>
            <template v-for="(person, i) in localInventory.authors">
              <person-inline :value="person" :key="i" v-b-modal.inventory-details-modal-person
                             @click="selectedPerson = person"></person-inline>
            </template>
          </li>
          <li class="list-inline-item me-3" v-if="localInventory.persons && localInventory.persons.length !== 0"><i
              class='bx bx-group'></i>
            <template v-for="(person, i) in localInventory.persons">
              <person-inline :value="person" :key="i" v-b-modal.inventory-details-modal-person
                             @click="selectedPerson = person"></person-inline>
            </template>
          </li>
          <li class="list-inline-item me-3"><i class='bx bx-map'></i> <span
              v-html="formatAddress(localInventory.address)"></span></li>
          <li class="list-inline-item me-3" v-if="localInventory.location"><i class='bx bx-map-pin'></i>
            {{ localInventory.location.name }}
          </li>
          <li class="list-inline-item me-3"><i class='bx bx-calendar'></i> <span
              v-html="formatDate(localInventory)"></span>
          </li>
          <li class="list-inline-item me-3" v-if="localInventory.format"><i class='bx bx-ruler'></i>
            {{ localInventory.format.string }}
          </li>
          <li class="list-inline-item me-3"><i class='bx bx-area'></i> {{
              localInventory.support ? localInventory.support.title : ''
            }}
          </li>
          <li class="list-inline-item me-3" v-if="localInventory.pages && localInventory.pages.length"><i
              class='bx bx-news'></i> {{
              formatPages(localInventory)
            }}
          </li>
        </ul>
        <b-card-text v-if="localInventory.observations">
          <h6>Observations</h6>
          <blockquote class="blockquote">
            {{ localInventory.observations }}
          </blockquote>
        </b-card-text>

        <b-card-text v-if="localInventory.state_report">
          <h6>Constat d'état</h6>
          <blockquote class="blockquote">
            {{ localInventory.state_report }}
          </blockquote>
        </b-card-text>
      </b-card-body>

      <b-modal id="inventory-details-modal-person" centered hide-footer
               size="lg"
               title-class="font-18"
               @hide="selectedPerson = null">
        <person-details v-if="selectedPerson" :person="this.selectedPerson"></person-details>
      </b-modal>
    </b-card>
  </Loader>
</template>
